import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=a5f6f14c&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=a5f6f14c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f6f14c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Button.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default})
